import CustomImage from '../../../../../../v2-components/Antd/Image';

export const checkRecipe = (recipe) => {
	if (recipe === undefined) {
		return <h3>El usuario no ha adjuntado receta/s para este producto.</h3>;
	}
	return <CustomImage src={recipe} width={100} />;
};
